import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { isNullOrUndefined } from '../../utils/typeChecks';

export class AliasTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any = queryResponse;
		const { aliases } = this.options;
		if (queryResponse) {
			for (const alias of aliases) {
				const { source, replacement } = alias;
				const replacementString = isNullOrUndefined(replacement) ? '' : replacement;
				response = response.toString().split(source).join(replacementString);
			}
		}
		return response;
	}
}